// Row geometry of every pick / tick list: read straight off the Customers list (GROUPED_GEOMETRY, groupedEdgePx,
// the 44px desktop list row). No literals here — one source for TickList, InlineRadioGroup and CalmRow.
import { foundation } from '../../../ui/tokens';
import { GROUPED_GEOMETRY } from '../../../ui/groupedListGeometry';
import { DESKTOP_LIST_ROW_HEIGHT_PX } from '../../../ui/desktopListRow';
import { GROUPED_LIST } from '../groupedList/groupedListTokens';
import { useFlushInset } from '../fullscreenFlow/flushInset';
import { useResponsiveLayout } from '../../../hooks/ui/useResponsiveLayout';

const { color, spacePx: sp, fontSize, fontWeight, fontFamily } = foundation;

/** @param {boolean} [touchOverride] force the touch (true) / web (false) standard. */
export function usePickRowGeometry(touchOverride) {
  const { isTouch } = useResponsiveLayout();
  const touch = touchOverride ?? isTouch;
  const edge = useFlushInset(touch);
  const row = GROUPED_GEOMETRY.touchRow;
  const slot = touch ? GROUPED_GEOMETRY.checkSlot.touch : GROUPED_GEOMETRY.checkSlot.web;
  return {
    touch,
    edge,
    minHeight: touch ? row.minHeightPx : DESKTOP_LIST_ROW_HEIGHT_PX,
    padY: touch ? `${row.padYPx}px` : sp[1],
    gap: slot.gap,
    box: slot.box,
    lineGap: row.lineGapPx,
    divider: `1px solid ${GROUPED_LIST.rowLine}`,
  };
}

/** Line 1: the name — semibold sm in the text colour. */
export const pickNameStyle = { fontFamily: fontFamily.sans, fontSize: fontSize.sm, fontWeight: fontWeight.semibold, color: color.neutral.text, lineHeight: 1.3, minWidth: 0 };
/** Line 2: muted sm, 4px under line 1. */
export const pickSubStyle = (lineGap) => ({ fontSize: fontSize.sm, fontWeight: fontWeight.normal, color: color.neutral.textMuted, marginTop: lineGap, lineHeight: 1.3 });
